/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const InStorePopover = ({
  isVisible, text, linkText, popoverContent, isLinkType
}) => {

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const storeSelectorClassName = classNames('store-selector sui-w-max sui-mt-1',
    'store-selector--mobile'
  );

  const contentClasses = classNames('store-selector__content',
    'store-selector__content--mobile');

  useEffect(() => {
    if (!isVisible) {
      setIsTooltipVisible(false);
    }
  }, [isVisible]);

  return (
    <div className={storeSelectorClassName}>

      {
        (isVisible || isLinkType)
           && (
             <div className="refinement__availability--pickupOrDelivery">
               <span>
                 <div
                   className="sui-font-regular sui-text-base sui-flex sui-leading-tight sui-items-center"
                 >
                   <span className="sui-px-1 sm:sui-mt-1">{text}</span>
                   <button
                     className="sui-pr-1 sui-flex sui-items-center sui-gap-1 sm:sui-mt-1"
                     type="button"
                     aria-label="store selector caret"
                     tabIndex="0"
                     onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                   >
                     <Link underline="always">
                       {linkText}
                     </Link>
                     {isTooltipVisible ? <ArrowUp size="small" /> : <ArrowDown size="small" />}
                   </button>
                 </div>
                 {isTooltipVisible && (
                   <div className="sui-grid">
                     <div className=" store-selector--wrapper col__10-12 col__10-12--xs">
                       <div className="store-selector--mobile__dropdown">
                         <span className="instore-sortbtn__dropdown__caret" />
                         <button
                           className="instore-sortbtn__dropdown__close-button sui-pl-4"
                           type="button"
                           aria-label="store selector dropdown close button"
                           tabIndex="-1"
                           onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                         />
                         <div className={contentClasses}>
                           { popoverContent }
                         </div>
                       </div>
                     </div>
                   </div>
                 )}
               </span>
             </div>
           )
      }
      {(!isVisible && !isLinkType) && (
        <div
          className="sui-font-regular sui-text-base sui-flex sui-leading-tight sui-items-center"
        >
          <span className="sui-px-1 sui-truncate">{`${text} ${linkText}`}</span>
        </div>
      )}
    </div>
  );
};

InStorePopover.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  popoverContent: PropTypes.node.isRequired,
  isLinkType: PropTypes.bool
};

InStorePopover.defaultProps = {
  linkText: '',
  isLinkType: false
};